require('./brokerCustomWalletLoader.scss');

const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const React = require('react');
const { BoxTabs } = require('commonsComponents/boxTabs');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { BrokerCustomViewsDropdown } = require('./brokerCustomViewsDropdown/brokerCustomViewsDropdown');
const { OKLink } = require('commonsComponents/OKLink');
const { ContentBox } = require('commonsComponents/contentBox');

// @actions
const { setActiveTab } = require('actions/myWallet');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { ACTIVE_TAB_CONTRACTS, BROKER_CUSTOM_WALLET_CONFIGURATION_URL } = require('constants/index');

class BrokerCustomWalletLoader extends React.Component {
    constructor(props) {
        super(props);
        this.onTabChange = this.onTabChange.bind(this);
        this.onContractTabSelect = this.onContractTabSelect.bind(this);
        this.state = {
            prevActiveTabValue: 0
        }
    }

    componentDidUpdate(prevProps) {
        const { immMyWalletCharts } = this.props;
        const immPrevMyWalletCharts = prevProps.immMyWalletCharts;
        const activeTab = immMyWalletCharts.get('activeTab');
        const activeTabChanged = immPrevMyWalletCharts.get('activeTab') !== activeTab;
        if (activeTab == ACTIVE_TAB_CONTRACTS && activeTabChanged) {
            this.onContractTabSelect(immPrevMyWalletCharts.get('activeTab'));
        }
    }

    onTabChange(value) {
        this.props.setActiveTab(value);
    }

    onContractTabSelect(value) {
        //We don't have contract tab so set previousSelected tab
        this.setState({
            prevActiveTabValue: value
        });
    }

    render() {
        const {
            immMyWalletCharts,
        } = this.props;

        let activeTab = immMyWalletCharts.get('activeTab');
        if (activeTab == ACTIVE_TAB_CONTRACTS) {
            activeTab = this.state.prevActiveTabValue;
        }

        const tabsNav = (
            <BoxTabs
                tabs={[
                    formatText('broker-myWalletProducts'),
                    formatText('broker-myWalletClassDeActivo')
                ]}
                activeTab={activeTab}
                handleSelectedTab={this.onTabChange}
                defaultTabIndex={activeTab}
                tabDisabled={false}//As asset allocation story OBK433-37452 activos and products tab will not be disable
                tabsAsPills={true}
                selectedActiveTab={true}
            />
        );

        const myWalletTitleIcon = (
            <div className="broker-custom-wallet-loader__icon-container">
                <OKLink onClick={this.props.handledPreferencesClick} extraClass="broker-custom-wallet-loader__icon-link" modifier="emphasize" to={BROKER_CUSTOM_WALLET_CONFIGURATION_URL}>
                    <OKTooltip
                        target={<i className="icon broker-custom-wallet-loader__title-icon icon-preferencias" />}
                        content="broker-myWalletTitleTooltip"
                        offset={[4, -6]} disableAdjustment={true}
                    />
                </OKLink>
            </div>
        );

        return (
            <div className="broker-custom-wallet-loader__wrapper">
                <ContentBox>
                    <div className="row">
                        <div className="broker-custom-wallet-loader__left-content col-sm-5">
                            {tabsNav}
                        </div>
                        <div className="broker-custom-wallet-loader__center-content col-sm-3">
                            <FormattedText className="broker-custom-wallet-loader__dropdown-label" value="broker-viewByPortfolio" />
                        </div>
                        <div className="broker-custom-wallet-loader__right-content col-sm-3">
                            <BrokerCustomViewsDropdown/>
                        </div>
                        <div className="broker-custom-wallet-loader__right-content col-sm-1">
                            {myWalletTitleIcon}
                        </div>
                    </div>
                </ContentBox>
            </div>
        );
    }
}

BrokerCustomWalletLoader.propTypes = {
    setActiveTab: PropTypes.func,
    immMyWalletCharts: PropTypes.object.isRequired,
    handledPreferencesClick: PropTypes.func
};

module.exports.constructor = BrokerCustomWalletLoader;
module.exports.BrokerCustomWalletLoader = connect(
    state => ({
        immMyWalletCharts: state.myWalletCharts,
    }),
    {
        setActiveTab: setActiveTab
    }
)(BrokerCustomWalletLoader);